import React, { Component } from "react";
import { connect } from "react-redux";
import { getNotificationList } from "./notificationActions";
import LoaderComponent from "../../app/common/util/LoaderComponent";
import moment from "moment";
import Paginater from "../home/tabView/table/Paginater";

const TYPE_SLUGS = {
  "Order Notification": "order",
  "Process Notification": "process",
  "Hardware Notification": "hardware",
  "Blanks Notification": "blanks",
  "Personnel Notification": "personnel",
  "Price Notification": "price",
  "Holiday Notification": "holiday",
  "Delay Notification": "delay",
  "Other Notification": "other",
};

const getTypeSlug = (type) => TYPE_SLUGS[type] || "other";

const getTypeShortLabel = (type) => {
  if (!type) return "Notification";
  return String(type).replace(/\s*Notification$/i, "") || type;
};

class NotificationList extends Component {
  componentDidMount() {
    this.props.getNotificationList();
  }

  renderEmpty = () => (
    <div className="notification-list-empty">
      <p className="notification-list-empty__title">No notifications yet</p>
      <p className="notification-list-empty__hint">
        Internal broadcasts will appear here when they are published.
      </p>
    </div>
  );

  renderCard = (notification, index) => {
    const type = notification.notification_type || "Other Notification";
    const slug = getTypeSlug(type);
    const author = (notification.author && notification.author.username) || "—";
    const email =
      (notification.author && notification.author.email) || "";
    const created = notification.created_on
      ? moment(notification.created_on).format("MMM D, YYYY · h:mm A")
      : "—";

    return (
      <article
        className={`notification-card notification-card--${slug}`}
        key={notification.id || index}
      >
        <header className="notification-card__header">
          <span className="notification-card__badge">
            <span className="notification-card__badge-dot" aria-hidden="true" />
            {getTypeShortLabel(type)}
          </span>
          <time className="notification-card__time" dateTime={notification.created_on}>
            {created}
          </time>
        </header>

        <p className="notification-card__body">{notification.text}</p>

        <footer className="notification-card__meta">
          <div className="notification-card__meta-item">
            <span className="notification-card__meta-label">From</span>
            <strong className="notification-card__meta-value">{author}</strong>
          </div>
          {email ? (
            <div className="notification-card__meta-item">
              <span className="notification-card__meta-label">Email</span>
              <strong className="notification-card__meta-value">{email}</strong>
            </div>
          ) : null}
        </footer>
      </article>
    );
  };

  render() {
    const { notificationList, fetchingList, getNotificationList } = this.props;

    if (fetchingList === true) {
      return (
        <div className="notification-list-shell">
          <LoaderComponent />
        </div>
      );
    }

    const results =
      (notificationList && notificationList.results) || [];
    const total = (notificationList && notificationList.count) || 0;

    return (
      <div className="notification-list-shell">
        <header className="notification-list-hero">
          <div>
            <p className="notification-list-hero__eyebrow">Internal</p>
            <h1 className="notification-list-hero__title">Notifications</h1>
            <p className="notification-list-hero__subtitle">
              Lab broadcasts, process updates, and operational messages
            </p>
          </div>
          {total > 0 ? (
            <div className="notification-list-hero__count" aria-label={`${total} notifications`}>
              <span className="notification-list-hero__count-value">{total}</span>
              <span className="notification-list-hero__count-label">total</span>
            </div>
          ) : null}
        </header>

        <div className="notification-list">
          {results.length === 0
            ? this.renderEmpty()
            : results.map(this.renderCard)}
        </div>

        {total > 0 ? (
          <div className="notification-list-pagination">
            <Paginater
              defaultCurrent={1}
              total={total}
              onChange={getNotificationList}
              defaultPageSize={40}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fetchingList: state.notification.fetchingList,
  notificationList: state.notification.notificationList,
});

const actions = {
  getNotificationList,
};

export default connect(
  mapStateToProps,
  actions
)(NotificationList);
